import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba9e0d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = {
  class: "profile__link",
  href: "/my-profile"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link profile__title" }, "Личный кабинет", -1 /* HOISTED */))
const _hoisted_4 = { class: "profile__avatar-container" }
const _hoisted_5 = ["src"]

import { onMounted, Ref, ref } from "vue";
import ProfileIcon from '@/common/icons/ProfileIcon.vue'
import api from "@/myProfileSection/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBlock',
  setup(__props) {

const avatarSrc: Ref<string> = ref('')

onMounted(async () => {
  const userInfo = await api.getUserInfo()

  if (userInfo.avatar) {
    avatarSrc.value = `/assets/uploads/user_avatars/${userInfo.avatar}`
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (avatarSrc.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "profile__avatar",
              src: avatarSrc.value,
              alt: "photo"
            }, null, 8 /* PROPS */, _hoisted_5))
          : (_openBlock(), _createBlock(ProfileIcon, {
              key: 1,
              class: "profile__icon",
              alt: "profile"
            }))
      ])
    ])
  ]))
}
}

})